import {
  call,
  uriSuiguanjia
} from "./bridge";
export default (config, opt = 1, ...cb) => {
  call(uriSuiguanjia('sgj://barStyle', {
    opt,
    config
  }))
  cb.forEach((v, i)=>{
    window[`r_item${i + 1}_cb`] = v
  })
}